import setData from '../data/set-data'
import {handleErrors, updateMarkup} from './handle-response'
import {showLoader, hideLoader} from '../loader'

export default function fetchPosts(archive, filterElement) {
    const data = setData(archive, filterElement)
    showLoader(archive)

    jQuery
        .post(mtt_archive_widget.ajax_url, data, response => {
            updateMarkup(response, archive)

            window.scrollTo({
                top: archive.offsetTop - 80,
                behavior: 'smooth'
            })
        })
        .fail(error => handleErrors(error))
        .always(() => hideLoader(archive))
}